import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PortalProtectedRoute = ({ component: Component, skipOnboardingCheck = false, ...rest }) => {
  const sessionUser = useSelector(state => state.users.user);
  const sessionLoaded = useSelector(state => state.users.sessionLoaded);

  return (
    <Route
      {...rest}
      render={props => {
        if (!sessionLoaded)            return null; // Wait for session restore
        if (!sessionUser)              return <Redirect to="/portal/login" />;
        if (!sessionUser.isClient)     return <Redirect to="/portal/login" />;
        if (!skipOnboardingCheck && !sessionUser.onboardingCompletedAt) {
          return <Redirect to="/portal/onboarding" />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default PortalProtectedRoute;
